import { IFieldBaseProps } from "common/components/Field";
import { FormContext } from "common/components/Form/FormContext";
import { RadioControl } from "common/components/Radio/RadioControl";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { parsePath } from "common/helpers/FormPath";

export interface IRadioProps extends IFieldBaseProps<"radio"> {
  size?: "sm" | "md";
  label: string;
  value?: string | boolean;
  borderless?: boolean;
  noBackground?: boolean;
  /** Optional callback function to be called on input */
  onChange?: (value: string | boolean) => void;
}

export const Radio: React.FC<IRadioProps> = ({
  id,
  label,
  name,
  disabled,
  size = "md",
  value,
  borderless = true,
  noBackground = false,
  onChange,
}) => {
  // Constants
  const inferredValue = value || label.toLowerCase().replace(" ", "_");
  const nameId = (id || name) + inferredValue;

  // Hooks
  const { rootPath, updateFormReducer } = React.useContext(FormContext);
  const dispatch = useDispatch();

  // Selectors
  const path = parsePath(name);
  const isChecked: boolean = useSelector((state: any) => {
    const reduxValue = state.getIn(rootPath.concat(path));
    return reduxValue === inferredValue;
  });

  // Methods
  const handleInput = () => {
    dispatch(updateFormReducer({ rootPath, name, value: inferredValue }));

    if (onChange) {
      onChange(inferredValue);
    }
  };

  return (
    <RadioControl
      isChecked={isChecked}
      value={inferredValue}
      onChange={handleInput}
      label={label}
      id={nameId}
      disabled={disabled}
      size={size}
      borderless={borderless}
      noBackground={noBackground}
    />
  );
};
